import classNames from 'classnames';
import sanitizeHtml from '@alltrails/core/utils/sanitizeHtml';
import IconTile from '@alltrails/denali/components/IconTile';
import TableRow from '@alltrails/denali/components/TableRow';
import SearchSparkle from '@alltrails/denali/icons/SearchSparkle';
import styles from './styles/styles.module.scss';

type Props = {
  html: string;
};

const NLSearchResultContent = ({ html }: Props) => {
  const icon = <IconTile icon={{ Component: SearchSparkle }} />;

  return (
    <TableRow
      className={classNames(styles.listItemContent, styles.noDescription)}
      leftContent={icon}
      label={<div className={classNames(styles.label, styles.htmlLabel)} dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />}
    />
  );
};

export default NLSearchResultContent;
